const TOKEN_STORAGE_KEY = 'news_admin_access_token';

export const getStoredAdminToken = () => sessionStorage.getItem(TOKEN_STORAGE_KEY);

export const setStoredAdminToken = (token) => {
  if (token) {
    sessionStorage.setItem(TOKEN_STORAGE_KEY, token);
  } else {
    sessionStorage.removeItem(TOKEN_STORAGE_KEY);
  }
};

export const clearStoredAdminToken = () => {
  sessionStorage.removeItem(TOKEN_STORAGE_KEY);
};

export const getAdminHeaders = (includeJson = false) => {
  const headers = {};
  if (includeJson) {
    headers['Content-Type'] = 'application/json';
  }
  const token = getStoredAdminToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

export const adminFetch = (url, options = {}) => {
  const hasBody = options.body !== undefined && options.body !== null;
  const includeJson =
    options.includeJson === true ||
    (options.includeJson !== false && hasBody && !(options.body instanceof FormData));

  return fetch(url, {
    ...options,
    credentials: 'include',
    headers: {
      ...getAdminHeaders(includeJson),
      ...(options.headers || {}),
    },
  });
};

export const checkAdminSession = async (apiUrl) => {
  const res = await adminFetch(`${apiUrl}/admin/auth/me`);
  if (!res.ok) {
    clearStoredAdminToken();
    return false;
  }
  return true;
};

export const loginAdmin = async (apiUrl, username, password) => {
  const res = await fetch(`${apiUrl}/admin/auth/login`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.detail || 'Login failed');
  }

  if (data.access_token) {
    setStoredAdminToken(data.access_token);
  }
  return data;
};

export const logoutAdmin = async (apiUrl) => {
  try {
    await adminFetch(`${apiUrl}/admin/auth/logout`, { method: 'POST' });
  } finally {
    clearStoredAdminToken();
  }
};

export const handleAdminAuthError = (response, navigate) => {
  if (response.status === 401) {
    clearStoredAdminToken();
    navigate('/admin/login', { replace: true, state: { from: '/admin/news' } });
    return true;
  }
  return false;
};

export const uploadNewsImage = async (apiUrl, file, navigate) => {
  const formData = new FormData();
  formData.append('file', file);

  let res;
  try {
    res = await adminFetch(`${apiUrl}/admin/news/upload-image`, {
      method: 'POST',
      body: formData,
      includeJson: false,
    });
  } catch (err) {
    if (err?.message === 'Failed to fetch' || err instanceof TypeError) {
      throw new Error(
        'Upload could not reach the server. Ensure the backend is running on port 8001 and refresh the page.'
      );
    }
    throw err;
  }

  if (navigate && handleAdminAuthError(res, navigate)) {
    throw new Error('Session expired. Please log in again.');
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = data.detail;
    if (Array.isArray(detail)) {
      throw new Error(detail.map((item) => item.msg || JSON.stringify(item)).join('\n'));
    }
    throw new Error(detail || 'Image upload failed');
  }
  return data.image_url;
};
